module.exports = __webpack_public_path__ + "img/LogoBlack.47a508ea.png";